import React from "react";
import { Link } from "react-router-dom";
import Collection_1 from "../../../assets/images/home_page_5/collection/01.png";
import Collection_2 from "../../../assets/images/home_page_5/collection/02.png";
import Collection_3 from "../../../assets/images/home_page_5/collection/03.png";

const collections = [
    {
        id: 1,
        title: "New Bangles Collection",
        img: Collection_1,
        discount: "-20% Off",
        bgClass: "bg-orange",
        textColor: "text-black",
    },
    {
        id: 2,
        title: "New Bangles Collection",
        img: Collection_2,
        discount: "-20% Off",
        bgClass: "bg-brown",
        textColor: "text-white",
    },
    {
        id: 3,
        title: "New Bangles Collection",
        img: Collection_3,
        discount: "-20% Off",
        bgClass: "bg-dark-brown",
        textColor: "text-white",
    },
];

const Collection = () => {
    return (
        <section id="collection-five" className="collection-five-main-block">
            <div className="container">
                <div className="row">
                    {collections.map((collection) => (
                        <div key={collection.id} className="col-lg-4">
                            <div className={`collection-five-block ${collection.bgClass}`}>
                                <div className="row align-items-center">
                                    <div className="col-xl-6 col-lg-7 col-6">
                                        <div className="collection-five-dtls">
                                            <span className={`badge text-bg-primary ${collection.textColor}`}>
                                                {collection.discount}
                                            </span>
                                            <h5 className="collection-five-title">
                                                <Link to="/Shop" title="" className={collection.textColor}>
                                                    {collection.title}
                                                </Link>
                                            </h5>
                                            <Link to="/Shop" title="" className="btn btn-primary-five">
                                                Shop now <i className="flaticon-right-arrow" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-5 col-6">
                                        <Link to="/Shop" title="">
                                            <img src={collection.img} className="img-fluid" alt={collection.title} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Collection;
